/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvb3Jpb24vUHJvamVjdHMvc2ltcGxpY2l0eUVuZ2luZS92YWxtdXN0L3ZhbG11c3RmZS9zcmMvYXBwL2FnYXRleHRzY3JlZW5zL3BkYS9pbnZlbnRvcnkvY2hhbmdlLXBhbGxldC9jaGFuZ2UtcGFsbGV0LmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0M6L1VzZXJzL29yaW9uL1Byb2plY3RzL3NpbXBsaWNpdHlFbmdpbmUvdmFsbXVzdC92YWxtdXN0ZmUvc3JjL2FwcC9hZ2F0ZXh0c2NyZWVucy9wZGEvaW52ZW50b3J5L2NoYW5nZS1wYWxsZXQvY2hhbmdlLXBhbGxldC5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/$$_gendir/app/agatextscreens/pda/inventory/change-pallet/change-pallet.component.scss.shim.ngstyle.ts